import { sendLinkToTealium, sendViewToTealium } from 'src/features/common/services/tealium-service';
import {
  EVENT_NAME,
  PAGE_NAME_PREFIX,
  PAGE_NAME,
  StaticVariables,
  PAGE_SECTION,
  PAGE_CHANNEL,
  PAGE_SUB_DOMAIN,
  PAGE_TYPE,
  JOURNEY_NAME,
  LINK_PREFIX,
  LINK_NAME,
  JOURNEY_STEP_NAME,
  FORM_ERROR_NAME,
  FORM_ERROR_TYPE,
} from 'src/features/common/types/tealium-service';

const staticVariables = (): StaticVariables => {
  return {
    page_url: window.location.href,
    page_section: PAGE_SECTION.BUY_POS,
    page_channel: PAGE_CHANNEL.VODAPAY_BUY_POS,
    page_subdomain: PAGE_SUB_DOMAIN.BUY_POS,
    page_type: PAGE_TYPE.WEBSITE,
  };
};

const TealiumService = {
  firstTimeLoginLanding: () => {
    sendViewToTealium({
      event_name: [EVENT_NAME.PAGE_VIEW],
      page_name: `${PAGE_NAME_PREFIX.BUY_POS}3rd party: ${PAGE_NAME.ACCOUNT_CREATION}: create password`,
      journey_name: JOURNEY_NAME.THIRD_PARTY_ACCOUNT_CREATION,
      ...staticVariables(),
    });
  },

  firstTimeLoginActions: (action: 'next' | 'back') => {
    sendLinkToTealium({
      event_name: [EVENT_NAME.UI_INTERACTION],
      page_name: `${PAGE_NAME_PREFIX.BUY_POS}3rd party: ${PAGE_NAME.ACCOUNT_CREATION}: create password`,
      link_name: `${LINK_PREFIX.BUY_POS}3rd party: ${LINK_NAME.ACCOUNT_CREATION}: create password: ${action}`,
      journey_name: JOURNEY_NAME.THIRD_PARTY_ACCOUNT_CREATION,
      ...staticVariables(),
    });
  },

  otpScreenLanding: () => {
    sendViewToTealium({
      event_name: [EVENT_NAME.PAGE_VIEW, EVENT_NAME.JOURNEY_STEP],
      page_name: `${PAGE_NAME_PREFIX.BUY_POS}: 3rd party: ${PAGE_NAME.ACCOUNT_CREATION}: otp`,
      journey_name: JOURNEY_NAME.THIRD_PARTY_ACCOUNT_CREATION,
      journey_step_name: JOURNEY_STEP_NAME.SMS_OTP,
      ...staticVariables(),
    });
  },

  onOtpScreenContinueFormError: (isUserError: boolean) => {
    sendLinkToTealium({
      event_name: [EVENT_NAME.UI_INTERACTION, EVENT_NAME.FORM_ERROR],
      page_name: `${PAGE_NAME_PREFIX.BUY_POS}: 3rd party: ${PAGE_NAME.ACCOUNT_CREATION}: otp`,
      link_name: `${LINK_PREFIX.BUY_POS}: 3rd party: ${LINK_NAME.ACCOUNT_CREATION}: otp: continue`,
      journey_name: JOURNEY_NAME.THIRD_PARTY_ACCOUNT_CREATION,
      form_error_name: FORM_ERROR_NAME.INCORRECT_OTP,
      form_error_type: isUserError ? FORM_ERROR_TYPE.USER_ERROR : FORM_ERROR_TYPE.SYSTEM_ERROR,
      form_error_code: isUserError ? 400 : 500,
      ...staticVariables(),
    });
  },

  onOtpScreenContinueSuccess: () => {
    sendLinkToTealium({
      event_name: [EVENT_NAME.UI_INTERACTION],
      page_name: `${PAGE_NAME_PREFIX.BUY_POS}: 3rd party: ${PAGE_NAME.ACCOUNT_CREATION}: otp`,
      link_name: `${LINK_PREFIX.BUY_POS}: 3rd party: ${LINK_NAME.ACCOUNT_CREATION}: otp: continue`,
      journey_name: JOURNEY_NAME.THIRD_PARTY_ACCOUNT_CREATION,
      ...staticVariables(),
    });
  },

  onOtpScreenResend: () => {
    sendLinkToTealium({
      event_name: [EVENT_NAME.UI_INTERACTION],
      page_name: `${PAGE_NAME_PREFIX.BUY_POS}: 3rd party: ${PAGE_NAME.ACCOUNT_CREATION}: otp`,
      link_name: `${LINK_PREFIX.BUY_POS}: 3rd party: ${LINK_NAME.ACCOUNT_CREATION}: otp: resend`,
      journey_name: JOURNEY_NAME.THIRD_PARTY_ACCOUNT_CREATION,
      ...staticVariables(),
    });
  },

  createPasswordScreenLanding: () => {
    sendViewToTealium({
      event_name: [EVENT_NAME.PAGE_VIEW, EVENT_NAME.JOURNEY_STEP],
      page_name: `${PAGE_NAME_PREFIX.BUY_POS}: 3rd party: ${PAGE_NAME.ACCOUNT_CREATION}: set password`,
      journey_name: JOURNEY_NAME.THIRD_PARTY_ACCOUNT_CREATION,
      journey_step_name: JOURNEY_STEP_NAME.SET_PASSWORD,
      ...staticVariables(),
    });
  },

  onCreatePasswordScreenActions: (action: 'set password' | 'cancel') => {
    sendLinkToTealium({
      event_name: [EVENT_NAME.UI_INTERACTION],
      page_name: `${PAGE_NAME_PREFIX.BUY_POS}: 3rd party: ${PAGE_NAME.ACCOUNT_CREATION}: set password`,
      link_name: `${LINK_PREFIX.BUY_POS}: 3rd party: ${LINK_NAME.ACCOUNT_CREATION}: set password: ${action}`,
      journey_name: JOURNEY_NAME.THIRD_PARTY_ACCOUNT_CREATION,
      journey_step_name: JOURNEY_STEP_NAME.SET_PASSWORD,
      ...staticVariables(),
    });
  },

  onCreatePasswordScreenFormError: () => {
    sendViewToTealium({
      event_name: [EVENT_NAME.PAGE_ERROR],
      page_name: `${PAGE_NAME_PREFIX.BUY_POS}: 3rd party: ${PAGE_NAME.ACCOUNT_CREATION}: set password`,
      journey_name: JOURNEY_NAME.THIRD_PARTY_ACCOUNT_CREATION,
      form_error_name: FORM_ERROR_NAME.FAILED_TO_SET_PASSWORD,
      form_error_type: FORM_ERROR_TYPE.SYSTEM_ERROR,
      form_error_code: 500,
      ...staticVariables(),
    });
  },
};

export default TealiumService;
